import React, { useEffect } from "react";
import { Container, Row } from "react-bootstrap";
import Cloud8 from "../../../Img/clouds8.png";
import AOS from "aos";

export default function GraphicDesignProfileContent() {
  useEffect(() => {
    AOS.init({
      once: true,
      offset: 120,
    });
  }, []);
  return (
    <>
      <section className="content-block">
        <Container>
          <Row>
            <div className="col-lg-12">
              <div
                className="sec-title"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="500"
              >
                <img className="cloud" src={Cloud8} alt="cloud" />
                <h2>
                  <span>What is graphic design?</span>
                </h2>
              </div>
            </div>
          </Row>
          <Row>
            <div className="col-lg-12">
              <div
                className="heading-text"
                data-aos="fade-up"
                data-aos-duration="1200"
                data-aos-delay="500"
              >
                Graphic design is the art of communication through visually
                perceivable content. It combines creativity, technology, and
                strategic thinking to convey messages, evoke emotions, and
                engage audiences. Whether it’s a striking logo, an eye-catching
                advertisement, or a user-friendly website, graphic design plays
                a crucial role in how businesses and individuals express
                themselves.
              </div>
            </div>
          </Row>
        </Container>
      </section>
    </>
  );
}
